/* eslint-env jquery */
/* global doFollowUrls */
import URI from 'urijs';
// import intlTelInput from 'intl-tel-input';
import { setupPhoneInputEvents } from './phone-input-module';

const currentUrl = window.location.href;

const Site = {
  onClick: () => {
    (function ($) {
      $('.clipboard').on('click', function () {
        Site.copyText(currentUrl);
      });
    })(jQuery);
  },

  onReady: () => {
    (function ($) {
      const $phoneInputs = $('.mobile');

      if ($phoneInputs.length > 0) {
        $phoneInputs.each(function () {
          const $input = $(this);
          setupPhoneInputEvents($input);
        });
      }

      $('.btn-open-in-modal').on('click', function (e) {
        e.preventDefault();
        $('#custom-modal-wrapper').modal('show');
      });

      const uri = new URI(currentUrl);
      const hashValue = uri.fragment();
      const parseHashValue = parseInt(hashValue);
      $('button#' + parseHashValue).removeClass('collapsed');
      $('#flush-collapse' + parseHashValue).addClass('show');

      const allAnchorTags = $('a');
      const externalUrl = allAnchorTags.filter('[href^="http"], [href^="//"], [href^="https"]');

      // Current website
      externalUrl
        .not('[href*="' + window.location.host + '"]')
        .attr('rel', 'noopener nofollow external noreferrer')
        .attr('target', '_blank');

      // External website
      externalUrl
        .filter('[href*="' + window.location.host + '"]')
        .attr('rel', 'follow')
        .attr('target', '_self');

      // Conditionally. some external links only we should allow to be do follow
      externalUrl.filter(doFollowUrls).attr('rel', 'follow');

      externalUrl.filter('[href*="dev.gupshup.io"], [href*="gupshup.io"]').attr('target', '_self');

      // Ticker to date time

      // console.log($('#event-countdown').attr('data-toDate'), 'test', parseInt($('#event-countdown').attr('data-toDate') + '000'));
      const liftoffTime = new Date(parseInt($('#event-countdown').attr('data-toDate') * 1000));
      if ($('#event-countdown').length) {
        $('#event-countdown').countdown({ until: liftoffTime });
      }
      Site.setCookieBasedOnUtmUrlParams();
    })(jQuery);
  },

  copyText: (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
  },
  copyTextByElement: (domElement) => {
    Site.copyText($(domElement).text());
    if (domElement === '#product-api-key') {
      const copyTextBtn = $('.showCopied');
      copyTextBtn.show().delay(1500).fadeOut();
    }
  },
  setCookieBasedOnUtmUrlParams: () => {
    const utmCookieName = 'utmParams';
    // Assuming lead_marketing_source will never exist in url param
    const allowedUrlParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'lead_marketing_source'];
    let utmQueryParamsAsObject = {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
      gclid: null,
    };
    let hasUtmParamsInUrl = false;
    const uri = new URI(currentUrl);
    const queryParams = uri.search(true);
    // const queryParamsAsString = uri.search();
    const utmCookieRawValue = Cookies.get(utmCookieName);
    utmQueryParamsAsObject['lead_marketing_source'] = currentUrl;
    Object.keys(queryParams).forEach((urlParam) => {
      if (allowedUrlParams.includes(urlParam)) {
        hasUtmParamsInUrl = true;
        utmQueryParamsAsObject[urlParam] = queryParams[urlParam];
      }
    });
    if (hasUtmParamsInUrl) {
      Cookies.set(utmCookieName, JSON.stringify(utmQueryParamsAsObject), { path: '/' });
    } else {
      // url params do not have UTM Params
      utmQueryParamsAsObject = utmCookieRawValue ? JSON.parse(decodeURIComponent(utmCookieRawValue)) : {};
      console.log('testUTMEmpty', utmQueryParamsAsObject);
    }
  },
};

const Scroll = {
  onInit: () => {
    (function ($) {
      let isOpen = false;
      $(window).scroll(function () {
        if ($(document).scrollTop() > $(document).height() * 0.5 && !isOpen) {
          isOpen = true;
          $('.next_blog').toggleClass('active');
        }
      });
      // Smooth scrolling to section on link click
      $('a.hashPg').on('click', function (event) {
        event.preventDefault();
        var target = $(this).attr('href'); // Get the href attribute of the clicked link

        // Check if the target section exists
        if ($(target).length) {
          var targetOffset = $(target).offset().top - 170; // Calculate the offset of the target section

          // Smooth scroll animation
          $('html, body').animate(
            {
              scrollTop: targetOffset,
            },
            800
          );
        }
      });
      $('.blogPopUpClose').on('click', function () {
        $('.next_blog').toggleClass('active');
      });
    })(jQuery);
  },
};

const AddCSSClass = {
  onInit: () => {},
};

window.copyTextByElement = Site.copyTextByElement;

export { Scroll, AddCSSClass, Site };
